import isEmpty from 'lodash/isEmpty'
import { UniqueUsersObj, UserOptions } from '../types'

export function getCreatedByAndUpdatedByUsers(rows): UniqueUsersObj | null {
  if (rows?.length === 0) return null

  const rowsWithProperties = rows?.filter(row => row?.properties)
  const usersObj = rowsWithProperties.reduce((acc, row) => {
    const ret = {
      ...acc,
      createdBy: { ...(acc.createdBy || {}) },
      updatedBy: { ...(acc.updatedBy || {}) },
    }

    const { createdBy, updatedBy } = row.properties
    const createdByName = createdBy?.name ?? null
    const updatedByName = updatedBy?.name ?? null

    if (createdByName && !ret.createdBy?.[createdByName]) {
      ret.createdBy[createdByName] = createdBy
    }

    if (updatedByName && !ret.updatedBy?.[updatedByName]) {
      ret.updatedBy[updatedByName] = updatedBy
    }

    return ret
  }, {})

  return usersObj
}

export function getUserOptions(uniqueUsersObj: UniqueUsersObj | null): UserOptions | null {
  if (!uniqueUsersObj || isEmpty(uniqueUsersObj)) return null

  const { createdBy, updatedBy } = uniqueUsersObj

  if (isEmpty(createdBy) && isEmpty(updatedBy)) return null

  const createdByOptions = Object.values(createdBy)
  const updatedByOptions = Object.values(updatedBy)

  return { createdBy: createdByOptions, updatedBy: updatedByOptions }
}
